const SMALL_BALANCE = '/api/v1/financial-coordinator/small-balance';

export const SMALL_BALANCE_ASSETS = `${SMALL_BALANCE}/assets`;
export const SMALL_BALANCE_CONVERT = `${SMALL_BALANCE}/convert`;
export const SMALL_BALANCE_HISTORY = `${SMALL_BALANCE}/history`;

/** Server maximum for `/assets`; anything above is clamped to it. */
export const SMALL_BALANCE_PAGE_LIMIT = 50;

/** Most assets one `/convert` request accepts; more is a 400 TOO_MANY_ASSETS. */
export const SMALL_BALANCE_CONVERT_MAX_ASSETS = 50;

/** Enough pages for far more eligible assets than anyone holds. */
export const SMALL_BALANCE_MAX_PAGES = 20;

/**
 * Convert answers in 1.5–2 s and the server waits up to ~20 s for a final
 * result, so the request needs more room than that before the client gives up.
 */
export const SMALL_BALANCE_CONVERT_TIMEOUT_MS = 30000;
